import {
  type BuildQueryStringOptions,
  buildURLSearchParams,
} from "~/services/market-data/market-data-filters/buildUrlSearchParams";

export const buildMarketDataQuery = (params: BuildQueryStringOptions, options: { canAccessFiguresAiV2: boolean }) => {
  const urlSearchParams = buildURLSearchParams(params, options);

  return Object.fromEntries(urlSearchParams);
};
